export default {
    abierto: false
}
